import React from 'react';
import { Badge } from '@/ui/badge';
import { X } from 'lucide-react';
import { Repository } from '@/shared/services/supabaseService';
import { Label } from '@/ui/label';

interface SelectedReposListProps {
  repositories: Repository[];
  selectedRepositories: string[];
  onRemove: (id: string) => void;
}

export const SelectedReposList: React.FC<SelectedReposListProps> = ({
  repositories,
  selectedRepositories,
  onRemove,
}) => {
  if (selectedRepositories.length === 0) return null;

  return (
    <div className="space-y-2">
      <Label className="font-mono text-xs uppercase text-muted-foreground font-bold">
        Selected Repositories ({selectedRepositories.length})
      </Label>
      <div className="flex flex-wrap gap-2 border border-neutral-200 dark:border-neutral-800 p-2 min-h-[40px] bg-neutral-50 dark:bg-neutral-900/10">
        {selectedRepositories.map(repoId => {
          const repo = repositories.find(r => r.id === repoId);
          return (
            <Badge
                key={repoId}
                variant="secondary"
                className="flex items-center gap-1 rounded-none font-mono text-xs border border-neutral-950 dark:border-neutral-100 bg-white dark:bg-black text-foreground hover:bg-neutral-100 dark:hover:bg-neutral-900 transition-colors"
            >
              {repo?.name || repoId}
              <button
                type="button"
                onClick={() => onRemove(repoId)}
                className="ml-1 hover:text-red-500 transition-colors"
              >
                <X className="h-3 w-3" />
              </button>
            </Badge>
          );
        })}
      </div>
    </div>
  );
};
